<template>
  <div class="grid grid-cols-1">
    <app-document-status-button
      class="status-btn border-4 border-blue rounded-full mt-1 mb-1 px-1"
      style="width:150px;"
      :class="requestIsMine ? 'bg-white' : 'bg-blue'"
      @click="changeDocumentActivities('request', documentId, requestStatus)"
      :status="requestStatus"
      :isMine="requestIsMine"
      :disabled="(requestStatus === 0 && !requestIsMine) || requestStatus === 8"
    >
      <template v-slot:buttonText>
        <lightning-icn
          class="inline mb-1 ml-1"
          :class="requestIsMine ? 'blue-icon' : 'white-icon'"
          width="15px"
          height="15px"
        ></lightning-icn>
        <span
          class="text-lg font-bold ml-0.5"
          :class="requestIsMine ? 'text-blue' : 'text-white'"
          >行</span
        >
        <span
          class="text-sm font-bold"
          :class="requestIsMine ? 'text-blue' : 'text-white'"
          >程</span
        >
      </template>
    </app-document-status-button>
    <app-document-status-button
      class="status-btn border-4 border-blue rounded-full mt-1 mb-1 px-1"
      style="width:150px;"
      :class="resultIsMine ? 'bg-white' : 'bg-blue'"
      @click="changeDocumentActivities('result', documentId, resultStatus)"
      :status="resultStatus"
      :isMine="resultIsMine"
      :disabled="(resultStatus === 0 && !resultIsMine) || resultStatus === 8"
    >
      <template v-slot:buttonText>
        <attach-icn
          class="inline mb-1 ml-1"
          :class="resultIsMine ? 'blue-icon' : 'white-icon'"
          width="15px"
          height="15px"
        ></attach-icn>
        <span
          class="text-lg font-bold ml-0.5"
          :class="resultIsMine ? 'text-blue' : 'text-white'"
          >概</span
        >
        <span
          class="text-sm font-bold"
          :class="resultIsMine ? 'text-blue' : 'text-white'"
          >要</span
        >
      </template>
    </app-document-status-button>
    <app-document-status-button
      class="status-btn border-4 border-blue rounded-full mt-1 mb-1 px-1"
      style="width:150px;"
      :class="memoryIsMine ? 'bg-white' : 'bg-blue'"
      @click="changeDocumentActivities('memory', documentId, memoryStatus)"
      :status="memoryStatus"
      :isMine="memoryIsMine"
      :disabled="(memoryStatus === 0 && !memoryIsMine) || memoryStatus === 8"
    >
      <template v-slot:buttonText>
        <receipt-icn
          fill-rule="evenodd"
          class="inline mb-1 ml-1"
          :class="memoryIsMine ? 'blue-icon' : 'white-icon'"
          width="13px"
          height="13px"
        ></receipt-icn>
        <span
          class="text-lg font-bold ml-1"
          :class="memoryIsMine ? 'text-blue' : 'text-white'"
          >費</span
        >
        <span
          class="text-sm font-bold"
          :class="memoryIsMine ? 'text-blue' : 'text-white'"
          >用</span
        >
      </template>
    </app-document-status-button>
  </div>
</template>

<script>
import AppDocumentStatusButton from '@/components/ui/uiToda/AppDocumentStatusButtonToda'
import LightningIcn from '@/assets/icons/lightning-new.svg?inline'
import AttachIcn from '@/assets/icons/attach.svg?inline'
import ReceiptIcn from '@/assets/icons/receipt.svg?inline'
import { usePoliticalActionDialog } from '@/services/politicalActionToda/usePoliticalActionDialog'

export default {
  name: 'AppDocumentStatusIndicator_TODA',

  components: {
    AppDocumentStatusButton,
    LightningIcn,
    AttachIcn,
    ReceiptIcn,
  },

  props: {
    requestStatus: {
      type: Number,
      default: null,
    },
    resultStatus: {
      type: Number,
      default: null,
    },
    memoryStatus: {
      type: Number,
      default: null,
    },
    documentId: {
      type: Number,
      required: true,
    },
    requestIsMine: {
      type: Boolean,
      default: false,
    },
    resultIsMine: {
      type: Boolean,
      default: false,
    },
    memoryIsMine: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    return { ...usePoliticalActionDialog() }
  },
}
</script>
